(function() {
    'use strict';
    angular.module('emarket.main.post').factory('PostPacker', function() {
        function Packer() {

        }
        Packer.prototype = {
            unpack: function(_rawData) {
                return _rawData;
            },
            unpackMany: function(_rawData, _collection) {
                _collection.$metadata = _rawData;
                return _rawData.data;
            },
            pack: function(_raw) {
                return _raw;
            }
        };
        return {};
    });
}());
